import axios from "../../customAxios.js"
import {
    BRAND_FAILED, BRAND_SUCCESS, BRAND_LOADING
} from "../constants/brandConstants"
import { toast } from 'react-toastify';

export const addBrand = (data) => async (dispatch) => {
    dispatch({
        type: BRAND_LOADING,
        payload: true
    });
    // Convert data object to FormData
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
    });

    await axios.post(`/api/v1/admin/create-brand`, formData, {
        headers: {
            "Content-Type": "multipart/form-data", // Ensure correct headers for FormData
        },
    }

    )
        .then(async response => {

            let data = response.data.user;

            dispatch({
                type: BRAND_SUCCESS,
                payload: data
            });
            toast.success(response.data.message);
            dispatch({
                type: BRAND_LOADING,
                payload: false
            })


        }).catch(async error => {
            toast.error(error?.message || error);
            dispatch({
                type: BRAND_FAILED,
                payload: error
            })
            dispatch({
                type: BRAND_LOADING,
                payload: false
            })
        })
}

export const getBrandData = (page = 1, limit = 10) => async (dispatch) => {
  dispatch({
      type: BRAND_LOADING,
      payload: true,
  });

  try {
      const response = await axios.get(`/api/v1/admin/brands?page=${page}&limit=${limit}`);
      
      // Adjust the data path as per your API response
      const brandData = response.data.user || response.data;

      dispatch({
          type: BRAND_SUCCESS,
          payload: brandData,
      });
  } catch (error) {
      toast.error(error?.message || error);

      dispatch({
          type: BRAND_FAILED,
          payload: error,
      });
  } finally {
      dispatch({
          type: BRAND_LOADING,
          payload: false,
      });
  }
};

export const brandGetDetails = (data) => async (dispatch) => {
    dispatch({
        type: BRAND_LOADING,
        payload: true
    });
    await axios.get(`/api/v1/users/getAllbrands?page=1&limit= 120`,)
        .then(async response => {
            dispatch({
                type: BRAND_SUCCESS,
                payload: response.data
            });

            dispatch({
                type: BRAND_LOADING,
                payload: false
            })


        }).catch(async error => {
            toast.error(error?.message || error);
            dispatch({
                type: BRAND_FAILED,
                payload: error
            })
            dispatch({
                type: BRAND_LOADING,
                payload: false
            })
        })
}

export const updateBrand = (brandId, data) => async (dispatch) => {
  dispatch({
    type: BRAND_LOADING,
    payload: true
  });

  try {
    const response = await axios.put(
      `/api/v1/admin/brand/${brandId}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success(response.data.message);

    dispatch({
      type: BRAND_SUCCESS,
      payload: response.data
    });

  } catch (error) {
    toast.error(error?.response?.data?.message || error.message);

    dispatch({
      type: BRAND_FAILED,
      payload: error
    });
  } finally {
    dispatch({
      type: BRAND_LOADING,
      payload: false
    });
  }
};
